import { useStore } from "@/store";
import { observer } from "mobx-react";
import Select from "react-select";
import React, { useMemo } from "react";

export const ProductCategorySelect = observer(() => {
  const { productCategories, activeProductCategory, setOrderProductCategory } =
    useStore();

  const options = useMemo(
    () =>
      productCategories.map((category) => ({
        label: category.name,
        value: category.id,
      })),
    [productCategories],
  );

  const value = useMemo(() => {
    if (!activeProductCategory) return null;

    return {
      label: activeProductCategory.name,
      value: activeProductCategory.id,
    };
  }, [activeProductCategory]);

  const handleChange = (option: any) => {
    const category = productCategories.find((c) => c.id === option.value);
    setOrderProductCategory(category);
  };

  return (
    <Select
      classNamePrefix="select"
      isSearchable={false}
      options={options}
      value={value}
      onChange={handleChange}
      styles={{
        container: (base) => ({
          ...base,
          width: "100%",
        }),
      }}
    />
  );
});
